"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusService = void 0;
const in_a_cache_1 = require("@ifit/in-a-cache");
const axios_1 = __importDefault(require("axios"));
const twoMinutesInSeconds = 120;
const oneSecondInMilliseconds = 1000;
const refreshAfterMilliseconds = twoMinutesInSeconds * oneSecondInMilliseconds;
class StatusService {
    constructor(args = {
        statusEndpoint: process.env.STATUS_ENDPOINT,
        cache: new in_a_cache_1.MemoryCache(),
        errorLogger: null,
    }) {
        this.args = args;
        this.logPrefix = '@ifit/this-is-fine.status endpoint';
    }
    get configured() {
        return !!this.args.statusEndpoint;
    }
    async isDown(name) {
        const safeName = this.toSafeName(name);
        const status = await this.getStatus();
        for (const statusName in status) {
            if (status[statusName] && safeName === statusName) {
                return true;
            }
        }
        return false;
    }
    async getStatus() {
        if (!this.args.cache) {
            return this.fetchStatus();
        }
        return this.args.cache.read({
            bucket: 'Status',
            id: 'All',
            retrieve: () => this.fetchStatus(),
            refreshAfterMilliseconds,
        });
    }
    async fetchStatus() {
        var _a;
        let promise;
        if (!this.configured) {
            (_a = this.args.errorLogger) === null || _a === void 0 ? void 0 : _a.error(`${this.logPrefix} not specified, pretending all is well!`);
            promise = Promise.resolve({ data: {} });
        }
        else {
            promise = axios_1.default.get(this.args.statusEndpoint, { timeout: 1000 }).catch((err) => {
                var _a, _b;
                (_b = (_a = this.args.errorLogger) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, `${this.logPrefix} errored, squelching and pretending all is well!`, err);
                return { data: {} };
            });
        }
        const { data: statusMap } = await promise;
        return Object.keys(statusMap).reduce((status, key) => (Object.assign(Object.assign({}, status), { [this.toSafeName(key)]: statusMap[key] })), {});
    }
    toSafeName(val) {
        return val.replace(/[^a-z0-9]/gi, '').toLowerCase();
    }
}
exports.StatusService = StatusService;
//# sourceMappingURL=status.js.map